// if we would have several reducers we need a meeting place
import { combineReducers } from "redux";
import itemReducer from "./itemReducer";
import chatReducer from "./chatReducer";
import toolReducer from "./toolReducer";
import errorReducer from "./errorReducer";
import authReducer from "./authReducer";
import menuReducer from "./menuReducer";

import projectReducer from "./projectReducer";
import changePageReducer from "./changePageReducer";
// import projectCharterReducer from "./projectCharterReducer";
import userReducer from "./userReducer";
import pictureReducer from "./pictureReducer";
import sendReducer from "./sendReducer";
import fileReducer from "./fileReducer";
import adminReducer from "./adminReducer";
import shareReducer from "./shareReducer";
import wsReducer from "./wsReducer";
import personalInfoReducer from "./personalInfoReducer";
import managerInfoReducer from "./managerInfoReducer";
import companyReducer from "./companyReducer";
import crmReducer from "./crmReducer";
import clientReducer from "./clientReducer";
import meetingMinutesReducer from "./meetingMinutesReducer.js";
import sessionReducer from "./sessionReducer";
import freeReducer from "./freeReducer.js";
import addressReducer from "./addressReducer.js";

export default combineReducers({
  item: itemReducer,
  chat: chatReducer,
  tool: toolReducer,
  error: errorReducer,
  auth: authReducer,
  menu: menuReducer,
  project: projectReducer,
  page: changePageReducer,
  user: userReducer,
  personalInfo: personalInfoReducer,
  managerInfo: managerInfoReducer,
  crm: crmReducer,
  meetingMinutes: meetingMinutesReducer,
  address: addressReducer,
  // projectCharter: projectCharterReducer,
  picture: pictureReducer,
  send: sendReducer,
  file: fileReducer,
  admin: adminReducer,
  share: shareReducer,
  ws: wsReducer,
  company: companyReducer,
  client: clientReducer,
  sessions: sessionReducer,
  free: freeReducer,
});
